<template>
<e-chart ref="chart" />
</template>

<script>
import {AXIS_LABEL, AXIS_LINE_STYLE, NUMBER_FONT_FAMILY} from './FactorCharts/chartStyle'
export default {
  name: 'SpeciesRatioChart',
  props: {
    data: {
      required: true,
      type: Object
    }
  },
  methods: {
    render (isReal) {
      let {dataTimes, series, beginTS, timeStep, data, currentQuery} = this.data

      let chartOpt = {
        toolbox: {
          feature: {
            saveAsImage: {}
          },
          right: 10
        },
        tooltip: {
          trigger: 'axis',
          appendToBody: true,
          formatter: (arg) => {
            let temp = {}
            let dataName = {}
            arg.forEach(item => {
              if (item.seriesType === 'line') {
                temp = item
                let index = (new Date(item.axisValue).getTime() - beginTS) / timeStep
                dataName = data[index]
              }
            })
            if (!isNaN(temp.value)) {
              return `${temp.axisValue}<br/>比值：${temp.value}<br/>${dataName[currentQuery.factorIds[0] + 'name']}: ${dataName[currentQuery.factorIds[0]]}${dataName.unit}<br/>${dataName[currentQuery.factorIds[1] + 'name']}: ${dataName[currentQuery.factorIds[1]]}${dataName.unit}`
            } else {
              return ''
            }
          }
        },
        grid: [{
          top: 40,
          right: 25,
          bottom: 45,
          left: 60,
          containLabel: true
        }],
        xAxis: {
          type: 'category',
          data: dataTimes
        },
        yAxis: {
          type: 'value',
          nameGap: 30,
          nameLocation: 'center',
          axisLine: {
            show: true,
            lineStyle: AXIS_LINE_STYLE
          },
          splitLine: {
            show: false
          },
          axisLabel: {
            ...AXIS_LABEL,
            fontFamily: NUMBER_FONT_FAMILY
          },
          position: 'left'
        },
        dataZoom: [{
          type: 'inside',
          start: dataTimes.length <= 72 ? 0 : ((dataTimes.length - 72) / dataTimes.length * 100).toFixed(0),
          end: 100,
          realtime: true,
          xAxisIndex: 0,
          minSpan: 5
        }, {
          type: 'slider',
          start: dataTimes.length <= 72 ? 0 : ((dataTimes.length - 72) / dataTimes.length * 100).toFixed(0),
          end: 100,
          realtime: true,
          xAxisIndex: 0,
          minSpan: 5,
          // height: 39,
          bottom: 9,
          left: 'center',
          handleIcon: 'M10.7,11.9H9.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4h1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
          handleSize: '70%',
          handleStyle: {
            color: '#fff',
            shadowBlur: 4,
            shadowColor: 'rgba(0, 0, 0, 0.15)',
            shadowOffsetX: 2,
            shadowOffsetY: 2
          },
          // dataBackground: {
          //   areaStyle: '#E4F0FF'
          // }
          fillerColor: 'rgba(228, 240, 255, .6)',
          borderColor: '#E4F0FF'
        }],
        series: series
      }

      this.$refs.chart.setOpt(chartOpt)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Data/SpeciesRatioChart.vue